<ng-container>{{ displayTitle() }}</ng-container>
